import { render, staticRenderFns } from "./ProductViewForm.vue?vue&type=template&id=1ee61b8e&scoped=true&"
import script from "./ProductViewForm.vue?vue&type=script&lang=ts&"
export * from "./ProductViewForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductViewForm.vue?vue&type=style&index=0&id=1ee61b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee61b8e",
  null
  
)

export default component.exports